export function localDate(now = new Date()): string {
  const offsetDate = new Date(now.getTime() - now.getTimezoneOffset() * 60_000)
  return offsetDate.toISOString().slice(0, 10)
}

export function dateFromString(value: string): Date {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day, 12)
}

export function dateString(date: Date): string {
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60_000)
  return offsetDate.toISOString().slice(0, 10)
}

export function addDays(value: string, amount: number): string {
  const date = dateFromString(value)
  date.setDate(date.getDate() + amount)
  return dateString(date)
}

export function monthRange(value: string, offset = 0): { from: string; to: string } {
  const date = dateFromString(value)
  date.setDate(1)
  date.setMonth(date.getMonth() + offset)
  const from = dateString(date)
  date.setMonth(date.getMonth() + 1, 0)
  return { from, to: dateString(date) }
}

export function startOfWeek(value: string): string {
  const date = dateFromString(value)
  const daysSinceMonday = (date.getDay() + 6) % 7
  date.setDate(date.getDate() - daysSinceMonday)
  return dateString(date)
}

/** ISO 8601 calendar week number (weeks start on Monday; week 1 contains 4 January). */
export function isoWeek(value: string): number {
  const date = dateFromString(value)
  const thursday = new Date(date)
  thursday.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7))
  const firstThursday = new Date(thursday.getFullYear(), 0, 4, 12)
  firstThursday.setDate(firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7))
  return 1 + Math.round((thursday.getTime() - firstThursday.getTime()) / (7 * 24 * 60 * 60 * 1000))
}
